<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon v-if="newStatsType">mdi-plus</v-icon>
        <v-icon v-else>mdi-pencil</v-icon>
        <v-toolbar-title v-if="modeStatsType === 'New'">Create Statistic Type</v-toolbar-title>
        <v-toolbar-title v-else-if="modeStatsType === 'Review'">Edit Statistic Type</v-toolbar-title>
        <v-toolbar-title v-else-if="modeStatsType === 'Query'">Query Statistic Type</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <message :messages="messages"></message>
          <v-layout wrap>
            <v-flex xs6 v-if="newStatsType">
              <v-text-field
                :label="labels.statsType"
                v-model="statsTypeForm.statsType"
                :error-messages="errors.has('statsType', 'statsTypeForm') ? errors.collect('statsTypeForm.statsType') : errors.collect('statsType')"
                data-vv-name="statsType"
                :data-vv-as="labels.statsType"
                v-validate="'required|param|max:4'"
                data-vv-scope="statsTypeForm"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.statsType }}</v-subheader>
              <div class="queryValue">{{ statsTypeForm.statsType }}</div>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                :readonly="modeStatsType === 'Query'"
                :label="labels.desc"
                v-model="statsTypeForm.statsTypeDesc"
                :error-messages="
                  errors.has('statsTypeDesc', 'statsTypeForm') ? errors.collect('statsTypeForm.statsTypeDesc') : errors.collect('statsTypeDesc')
                "
                data-vv-name="statsTypeDesc"
                :data-vv-as="labels.desc"
                v-validate="'required|entry|max:40'"
                data-vv-scope="statsTypeForm"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ statsTypeForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ statsTypeForm.createdDate | formatDate }}</div>
            </v-flex>
            <v-flex xs6 v-if="!newStatsType">
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ statsTypeForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6 v-if="!newStatsType">
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ statsTypeForm.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
          <span>Cancel</span>
          <v-icon right dark>mdi-cancel</v-icon>
        </v-btn>
        <v-btn color="primary" v-if="modeStatsType !== 'Query'" dark @click="doSaveStatsType">
          Save Statistic Type
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <template v-if="!newStatsType">
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-view-list</v-icon>
          <v-toolbar-title>Statistic Value List</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNewStatsVal">
            New Statistic Value
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-card>
          <v-data-table
            :headers="statsValHeaders"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.statsVal }}</td>
                <td class="text-xs-left">{{ row.item.statsValDesc }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReviewStatsVal(row.item.statsVal)"
                    query
                    @query="doQueryStatsVal(row.item.statsVal)"
                    remove
                    @remove="doDeleteStatsVal(row.item.statsVal)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </template>
    </v-card>
    <v-dialog v-model="statsValDialog" width="800px" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newStatsVal">mdi-plus</v-icon>
          <v-icon v-else-if="reviewStatsVal">mdi-pencil</v-icon>
          <v-icon v-else-if="queryStatsVal">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newStatsVal">Create New Statistic Value</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewStatsVal">Edit Statistic Value</v-toolbar-title>
          <v-toolbar-title v-else-if="queryStatsVal">Query Statistic Value</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newStatsVal">
                <v-text-field
                  :label="labels.statsVal"
                  v-model="statsValForm.statsVal"
                  :error-messages="errors.has('statsVal', 'statsValForm') ? errors.collect('statsValForm.statsVal') : errors.collect('statsVal')"
                  data-vv-name="statsVal"
                  :data-vv-as="labels.statsVal"
                  v-validate="'required|param|max:4'"
                  data-vv-scope="statsValForm"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.statsVal }}</v-subheader>
                <div class="queryValue">{{ statsValForm.statsVal }}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryStatsVal"
                  :label="labels.desc"
                  v-model="statsValForm.statsValDesc"
                  :error-messages="
                    errors.has('statsValDesc', 'statsValForm') ? errors.collect('statsValForm.statsValDesc') : errors.collect('statsValDesc')
                  "
                  data-vv-name="statsValDesc"
                  :data-vv-as="labels.desc"
                  v-validate="'required|entry|max:40'"
                  data-vv-scope="statsValForm"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ statsValForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ statsValForm.createdDate | formatDate }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newStatsVal">
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ statsValForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newStatsVal">
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ statsValForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
          <v-btn v-show="!queryStatsVal" color="primary" text @click.native="doSaveStatsVal">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm ref="confirmDelete"> Are you sure you want to delete the selected Statistics Value? ({{ selectedStatsVal }}) </confirm>
  </lazy-div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { format, toDate } from 'date-fns'
export default {
  data() {
    return {
      labels: {
        statsType: 'Statistic Type',
        statsVal: 'Statistic Value',
        desc: 'Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      statsTypeForm: {
        statsType: null,
        statsTypeDesc: null,
        mtrRiskFact: false,
        pkgRiskFact: false,
        cargoRiskFact: false,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      statsValHeaders: [
        { text: 'Statistic Value', value: 'statsVal' },
        { text: 'Description', value: 'statsValDesc' },
        TableConst.tableActionHeader
      ],
      statsValForm: {
        statsType: this.statsType,
        statsVal: null,
        statsValDesc: null,
        defAsBen: false,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      statsValDialog: false,
      newStatsVal: false,
      reviewStatsVal: false,
      queryStatsVal: false,
      selectedStatsVal: null,
      submitting: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      if (!this.newStatsType) {
        const apiURI = this.menu.statsType
        if (apiURI) {
          try {
            const expand = {
              statsType: this.statsType
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.statsTypeForm.statsType = data.statsType.statsType
              this.statsTypeForm.statsTypeDesc = data.statsType.statsTypeDesc
              this.statsTypeForm.createdBy = data.createdBy
              this.statsTypeForm.createdDate = data.createdDate
              this.statsTypeForm.modifiedBy = data.modifiedBy
              this.statsTypeForm.modifiedDate = data.modifiedDate
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
        await this.fetchStatsValList()
      } else {
        this.statsTypeForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.statsTypeForm.createdDate = format(toDate(Date.now()), 'yyyy-MM-dd')
      }
    },
    async doSaveStatsType() {
      this.resetMessages()
      this.$validator.validateAll('statsTypeForm').then((result) => {
        if (result) {
          const config = {
            method: this.newStatsType ? 'post' : 'put',
            url: this.newStatsType ? this.menu.createStatsType : this.menu.updateStatsType,
            data: this.statsTypeForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.$router.push({
                  name: 'statsTypeDet',
                  params: {
                    statsType: this.statsTypeForm.statsType
                  }
                })
                this.$parent.$parent.$parent.$emit('setDesc', this.statsTypeForm.statsTypeDesc)
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async fetchStatsValList() {
      this.resetMessages()
      const apiURI = this.menu.statsValList
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            statsType: this.statsType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          this.items = []
          const { data } = result.data
          if (data) {
            data.map((statsVal) => {
              const convertList = {
                statsVal: statsVal.statsVal,
                statsValDesc: statsVal.statsValDesc
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doReviewStatsVal(statsVal) {
      this.doFetchStatsVal(statsVal)
      this.reviewStatsVal = true
      this.queryStatsVal = false
      this.newStatsVal = false
    },
    async doQueryStatsVal(statsVal) {
      this.doFetchStatsVal(statsVal)
      this.reviewStatsVal = false
      this.queryStatsVal = true
      this.newStatsVal = false
    },
    doFetchStatsVal(statsVal) {
      this.resetMessages()
      const apiURI = this.menu.statsVal
      if (apiURI) {
        const expand = {
          statsType: this.statsType,
          statsVal
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.statsValForm.statsType = data.statsVal.statsType
              this.statsValForm.statsVal = data.statsVal.statsVal
              this.statsValForm.statsValDesc = data.statsVal.statsValDesc
              this.statsValForm.createdBy = data.createdBy
              this.statsValForm.createdDate = data.createdDate
              this.statsValForm.modifiedBy = data.modifiedBy
              this.statsValForm.modifiedDate = data.modifiedDate
              this.statsValDialog = true
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doNewStatsVal() {
      this.statsValForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.statsValForm.createdDate = format(toDate(Date.now()), 'yyyy-MM-dd')
      this.newStatsVal = true
      this.reviewStatsVal = false
      this.queryStatsVal = false
      this.statsValDialog = true
    },
    async doSaveStatsVal() {
      this.resetMessages()
      this.$validator.validateAll('statsValForm').then((result) => {
        if (result) {
          const config = {
            method: this.newStatsVal ? 'post' : 'put',
            url: this.newStatsVal ? this.menu.createStatsVal : this.menu.updateStatsVal,
            data: this.statsValForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.fetchStatsValList()
                this.doClose()
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doDeleteStatsVal(statsVal) {
      this.resetMessages()
      if (statsVal) {
        const expand = {
          statsType: this.statsType,
          statsVal
        }
        const apiURI = this.menu.checkDeleteStatsVal
        const apiURI2 = this.menu.deleteStatsVal
        if (apiURI && apiURI2) {
          try {
            await this.$http.get(expandURI(apiURI, expand))
            this.selectedStatsVal = statsVal
            const prompt = await this.$refs.confirmDelete.doPopUp()
            if (prompt) {
              const result = await this.$http.delete(expandURI(apiURI2, expand))
              const { data } = result
              this.notify(data)
              this.fetchStatsValList()
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        }
      }
    },
    doClose() {
      this.resetMessages()
      this.statsValForm.statsVal = null
      this.statsValForm.statsValDesc = null
      this.newStatsVal = false
      this.reviewStatsVal = false
      this.queryStatsVal = false
      this.statsValDialog = false
    },
    doCancel() {
      this.$router.push({ name: 'statsTypeVal' })
    }
  },
  computed: {
    newStatsType() {
      return this.statsType === 'new'
    },
    menu() {
      return this.$store.state.statsTypeParam.menu
    },
    modeStatsType() {
      return this.$route.params.modeStatsType
    }
  },
  watch: {
    statsType(value) {
      this.doInit()
      this.statsValForm.statsType = value
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  props: ['statsType'],
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
